import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="text-center lg:text-left">
      <section className="mb-8 section">
        <div className="container">
          <div className="flex flex-col justify-between space-y-8 lg:flex-row">
            <div>
              <h1 className="mb-4 font-serif text-2xl font-semibold">
                software developemnt with cutting edge tech.
              </h1>
              <Link
                to="/contact"
                className="font-serif text-5xl font-bold underline transition-colors duration-300 lg:text-8xl hover:text-sky-500"
              >
                Get in touch
              </Link>
            </div>
            <div>
              <h1 className="mb-4 font-serif text-2xl font-semibold">
                Services
              </h1>
              <ul className="text">
                <li>Website development</li>
                <li>Mobile App development</li>
                <li>Desktop App development</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="py-6 text-center border-t border-slate-100 text">
        Paul Chisenga @ {new Date().getFullYear()} Portfolio |
      </div>
    </div>
  );
};

export default Footer;
